import { useEffect, useState } from "react";
import { signInWithPopup, signOut } from "firebase/auth";
import { Navigate } from "react-router-dom";
import { ALLOWED_DOMAIN, auth, isAllowedUser, provider } from "../lib/firebase";
import { useAuth } from "../hooks/useAuth";
import { Header } from "../components/Header";

export function Login() {
  const { loading, allowed } = useAuth();
  const [error, setError] = useState("");
  const [signingIn, setSigningIn] = useState(false);

  useEffect(() => {
    setError("");
  }, []);

  if (loading) {
    return (
      <>
        <Header />
        <main />
      </>
    );
  }

  if (allowed) {
    return <Navigate to="/" replace />;
  }

  const onSignIn = async () => {
    setError("");
    setSigningIn(true);
    try {
      const { user } = await signInWithPopup(auth, provider);
      if (!isAllowedUser(user)) {
        await signOut(auth);
        setError(`Only @${ALLOWED_DOMAIN} accounts are allowed.`);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setSigningIn(false);
    }
  };

  return (
    <>
      <Header />
      <main>
        <div className="login-view">
          <p>Please sign in with your Originstamp Google account.</p>
          <button onClick={onSignIn} disabled={signingIn}>
            Sign in with Google
          </button>
          {error && <p className="error-msg">{error}</p>}
        </div>
      </main>
    </>
  );
}
